'use client';
import MobileBurgerIcon from '@/assets/icons/icon-burger.svg';
import MobileHeartIcon from '@/assets/icons/icon-heart.svg';
import { SearchInput, SearchInputMobile } from '@/components';
import { MenuDetailsFragment } from '@/graphql';
import { Link } from '@/i18n/navigation';
import { useState } from 'react';
import { Button } from 'rsuite';
import DrawerMobile from './DrawerMobile';
import styles from './top-mobile.module.scss';

const HeaderTopMobile = ({
  menu,
  loading,
}: {
  menu: MenuDetailsFragment | null | undefined;
  loading: boolean;
}) => {
  const [open, setOpen] = useState(false);

  const handleOpenMobileDrawer = () => {
    setOpen(true);
  };
  return (
    <header className={styles.headerTopMobile}>
      <Button onClick={handleOpenMobileDrawer} className={styles.mobileBurger}>
        <MobileBurgerIcon />
      </Button>
      <div className={styles.searchWrapper}>
        <div className={styles.inputSearchDesktop}>
          <SearchInput />
        </div>
        <div className={styles.inputSearchMobile}>
          <SearchInputMobile />
        </div>
      </div>
      <Link href={'/pages/favorites'} className={styles.mobileLike}>
        <MobileHeartIcon />
      </Link>
      <DrawerMobile
        open={open}
        setOpen={setOpen}
        menu={menu}
        loading={loading}
      />
    </header>
  );
};

export default HeaderTopMobile;
